"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PDFControl = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _PDFControlPanel = _interopRequireDefault(require("./PDFControlPanel"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PDFControl = exports.PDFControl = function PDFControl(_ref) {
  var program = _ref.program,
    onSourceChanged = _ref.onSourceChanged;
  var pdfLayer = (0, _react.useMemo)(function () {
    return program.layers.find(function (layer) {
      return [_constants.PDF_FILE].includes(layer.source.type);
    });
  }, [program]);
  if (!pdfLayer) return null;
  var pdfSource = pdfLayer.source;
  var activePage = pdfSource.value.activePage;
  var onPageClick = function onPageClick(pageNumber) {
    pdfSource.value.activePage = pageNumber;
    onSourceChanged(pdfSource._id, pdfSource.value);
  };
  return _react["default"].createElement("div", {
    "data-testid": "pdf-control"
  }, _react["default"].createElement(_PDFControlPanel["default"], {
    onPageClick: onPageClick,
    pdfSource: pdfSource.value.url,
    activePage: activePage ? activePage : 1
  }));
};
PDFControl.propTypes = {
  program: _propTypes["default"].object.isRequired,
  onSourceChanged: _propTypes["default"].func.isRequired
};